import {ExperimentNames, getEventId, getEventTitle} from '@wix/wix-events-commons-statics'
import {ChevronRight} from '@wix/wix-ui-icons-common'
import {useExperiments, useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {useEventDateInformation} from '../../../../../../../../../../commons/hooks/dates'
import {isMultiDay} from '../../../../../../../../../../commons/selectors/event'
import {useWidgetState} from '../../../../../../../hooks/state-provider'
import {getMultiDayText} from '../../../../../../../selectors/events'
import s from '../monthly-calendar-event-list.scss'
import {MonthlyCalendarEventListItemProps} from './interfaces'

export const MonthlyCalendarEventListItem = ({
  selectedDate,
  event,
  onClick,
  onKeyPress,
}: MonthlyCalendarEventListItemProps) => {
  const {t} = useTranslation()
  const {startDate, startTime} = useEventDateInformation(getEventId(event))
  const {experiments} = useExperiments()
  const multiDay = useWidgetState(state => isMultiDay(state, event))
  const multiDayText = useWidgetState(state => getMultiDayText(state, getEventId(event), selectedDate, t))

  const calendarRevampEnabled = experiments.enabled(ExperimentNames.CalendarRevamp)

  return (
    <li
      className={s.event}
      onClick={onClick}
      onKeyPress={onKeyPress}
      tabIndex={0}
      data-hook={`event-list-item-${getEventId(event)}`}
    >
      <div className={s.info}>
        {calendarRevampEnabled ? (
          <>
            <div className={s.title} data-hook={`event-title-${getEventId(event)}`}>
              {getEventTitle(event)}
            </div>
            <div className={s.time} data-hook={`event-time-${getEventId(event)}`}>
              {multiDay ? multiDayText : startTime}
            </div>
          </>
        ) : (
          <>
            <div className={s.time} data-hook={`event-time-${getEventId(event)}`}>
              {multiDay ? multiDayText : startDate}
            </div>
            <div className={s.title} data-hook={`event-title-${getEventId(event)}`}>
              {getEventTitle(event)}
            </div>
          </>
        )}
      </div>
      {!calendarRevampEnabled && (
        <div className={s.chevron}>
          <ChevronRight size="1.6em" />
        </div>
      )}
    </li>
  )
}
